const roleFields = [
  {
    name: "name",
    label: "Role Name",
    type: "text",
    placeholder: "Enter role name",
  },
];

export default roleFields;
